import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ModalInformation(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter" align="center" style ={{marginLeft:"auto",marginRight:"auto"}}>
            Hola. Un asesor ya está trabajando para ti.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p align="center">
            Pronto se comunicará contigo.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.redirect}>Aceptar</Button>
      </Modal.Footer>
    </Modal>
  );
}

export {ModalInformation}
